"use client";
import { isTouchDevice } from "@/app/common/Utils";
import { useEffect } from "react";

export const MobileTableCheck = () => {
	useEffect(() => {
		// Funktion zur Prüfung der Gerätegröße
		const handleResize = () => {
			const isMobile = isTouchDevice();

			// Body-Klasse setzen oder entfernen
			if (isMobile) {
				document.body.classList.add("mobile-table-true");
			} else {
				document.body.classList.remove("mobile-table-true");
			}
		};

		// Event Listener hinzufügen
		window.addEventListener("resize", handleResize);
		document.addEventListener("visibilitychange", handleResize);

		// Cleanup-Funktion: Event Listener entfernen, wenn das Component unmounted wird
		return () => {
			window.removeEventListener("resize", handleResize);
			document.removeEventListener("visibilitychange", handleResize);
		};
	}, []); // Keine Abhängigkeiten, da `handleResize` intern `setState` verwendet

	return <></>;
};
